import { gql } from '@apollo/client';
import { PostProject } from '../contentPage/postDetail';
import { PostSubcategory } from '../../common/helpers/domain/postCategories';
import { PropertyType } from '../../common/helpers/domain/propertyTypes';

export const HERO_VIDEO_QUERY = gql`
  query HeroVideo(
    $postCategory: [String]
    $propertyType: String
    $tag: String
  ) {
    heroVideo: heroVideoPost(
      postCategory: $postCategory
      propertyType: $propertyType
      tag: $tag
    ) {
      id
      link
      title
      excerpt
      author {
        id
        name
      }
      postCategory
      videoType
      featuredImage {
        url
      }
      project {
        id
        name
        propertyType
        developer
        location {
          zone {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
          district {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
          road {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
        }
        transportations {
          value
          label
          link
        }
        priceTypes {
          starting_price
          level {
            value
            label
          }
        }
      }
    }
  }
`;

export interface HeroVideoPostQueryResponse {
  heroVideo: HeroVideoInfo;
}

export interface HeroVideoPostQueryRequest {
  postCategory?: PostSubcategory[];
  propertyType?: PropertyType;
  tag?: string;
}

export interface HeroVideoInfo {
  id: number;
  title: string;
  excerpt: string;
  author: {
    id: number;
    name: string;
  };
  postCategory: PostSubcategory;
  link: string;
  videoType: string;
  project: PostProject;
  featuredImage: {
    url: string;
  };
}
